import { useEffect } from "react";
import { useSettings } from "@/hooks/useSettings";

// Uses the uploaded logo/favicon as the browser tab icon; keeps it in sync after refresh.
export default function SiteMeta() {
  const { settings } = useSettings();
  useEffect(() => {
    const icon = settings?.favicon || settings?.logo;
    if (!icon) return;
    document.querySelectorAll("link[rel~='icon']").forEach((el) => el.parentNode.removeChild(el));
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = icon;
    document.head.appendChild(link);
  }, [settings]);
  return null;
}
